import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Injectable } from "@angular/core";
import { UserStore } from "../stores/user.store";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly userStore: UserStore,
    private readonly router: Router
  ) {}

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const cleanUrl = this.getCleanRouteUrl(state.url);
    const hasCallbackFragment = this.hasKeycloakCallbackFragment(state.url);

    if (await this.userStore.checkAuthenticated()) {
      return hasCallbackFragment ? this.router.parseUrl(cleanUrl) : true;
    }

    const isLoggedIn = await this.userStore.loginWithKeycloak(this.getRedirectUri(cleanUrl));
    return isLoggedIn && hasCallbackFragment ? this.router.parseUrl(cleanUrl) : isLoggedIn;
  }

  private getRedirectUri(url: string): string {
    return `${window.location.origin}${url}`;
  }

  private getCleanRouteUrl(url: string): string {
    const pathWithoutFragment = url.split("#")[0] || "/";
    return pathWithoutFragment === "/" ? "/home" : pathWithoutFragment;
  }

  private hasKeycloakCallbackFragment(url: string): boolean {
    const fragment = url.split("#")[1];
    if (!fragment) return false;

    const params = new URLSearchParams(fragment);
    return params.has("state") && params.has("code");
  }
}
